<template>
  <component :is="resolvedComponent" v-bind="$attrs"></component>
</template>

<script>
  import clientConfig from '@/client_customs/config';

  export default {
    inheritAttrs: false,
    props: {
      name: { type: String, required: true },
    },
    computed: {
      resolvedComponent() {
        return clientConfig.clientCustomComponents?.[this.name] || this.name;
      },
    },
  };
</script>
